import { render, staticRenderFns } from "./AddSpocCourse.vue?vue&type=template&id=dce8311c&scoped=true&"
import script from "./AddSpocCourse.vue?vue&type=script&lang=js&"
export * from "./AddSpocCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddSpocCourse.vue?vue&type=style&index=0&id=dce8311c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce8311c",
  null
  
)

export default component.exports